import _base from './_base-module'

const state = {
  menuVisible: false,
  designSummary: false,
  infoDialog: false,
  modelPicker: false,
  materialSummary: '',
  optionSummary: '',
  optionGroupSummary: ''
}

const getters = {
  ..._base.getters,
  getState (state) {
    return state
  }
}

const actions = {}

const mutations = {
  setProperty (state, payload) {
    state[payload.property] = payload.value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
